import { ThemeUICSSObject, getColorsByPath, spacing } from '@apia/theme';
/* IMPORT HERE */

const tabPrimary: ThemeUICSSObject = {
  variant: 'layout.common.components.accordion.default',

  '&>button': {
    variant: 'buttons.accordion-primary',
    '*': {
      color: 'palette.primary.contrastText',
    },
  },
  '&>div>div>*': {
    p: spacing(7),
    bg: 'tab.backgroundColor',
  },

  ...getColorsByPath('tab'),
  /* PREPEND HERE */
};

export default tabPrimary;
